import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const cscPlpFilter = {
  gap: css`var(--csc-plp-filters-gap, ${csSpacing.spacing06})`,
}

export const style = css`
  :host {
    display: block;
    --cse-list-item-justify-content: space-between;
  }
  cse-badge {
    --cse-badge-floating-border-width: 0px;
    --cse-badge-small-line-height: 0;

  }
  .plp-filters-container {
    position: relative;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 10;
    pointer-events: none;
  }

  /* Mobile view - show button and slide-in (mobile and tablet, below medium) */
  .mobile-view {
    display: block;

    @media(min-width: ${SCREENS.medium}) {
      display: none;
    }
  }

  /* Desktop view - show filters directly (medium screens and up) */
  .desktop-view {
    display: none;

    @media(min-width: ${SCREENS.medium}) {
      display: block;
    }
  }

  .mobile-filters-button {
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    z-index: 1;
    padding: 0;
  }

  .mobile-filters-button cse-button {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 24px;
    width: 100%;
  }

  .mobile-filters-content {
    padding: ${csSpacing.spacing04};
    display: flex;
    flex-direction: column;
    gap: ${cscPlpFilter.gap};
  }

  .mobile-filters-container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${cscPlpFilter.gap};
  }

  .plp-filters {
    display: flex;
    flex-flow: column;
    gap: ${cscPlpFilter.gap};
  }

  .plp-filters-skeleton {
    display: flex;
    flex-flow: column;
    gap: ${cscPlpFilter.gap};
  }

  .plp-filters-skeleton cse-skeleton {
    width: 100%;
  }
`
